import { CdkStepper } from '@angular/cdk/stepper';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { MatStepperCustomStepComponent } from './mat-stepper-custom-step/mat-stepper-custom-step.component';
import { MatDialogRef } from '@angular/material/dialog';

export type ButtonTextByStep = string[];

@Component({
  selector: 'ew-mat-stepper-custom',
  templateUrl: './mat-stepper-custom.component.html',
  styleUrls: ['./mat-stepper-custom.component.scss'],
  providers: [{ provide: CdkStepper }],
})
export class MatStepperCustomComponent implements AfterViewInit {
  @Input() progressBar: boolean = true;
  @Input() showLogo: boolean = true;
  @Input() error: boolean = false;
  @Input() alignItems: 'start' | 'center' | 'end' = 'start';
  @Input() sendIn: 'last' | 'penultimate' = 'last';
  @Input() textForSendButton: string = 'shared:send';
  @Input() textForCloseButton: string = 'shared:close';
  @Input() nextButtonLabels: ButtonTextByStep = [];
  @Input() previousButtonLabels: ButtonTextByStep = [];
  @Input() classForSendButton: string = 'primary';
  @Input() classForCloseButton: string = 'warn';
  @Input() useCloseButton: boolean = false;
  @Input() validations: boolean[] = [];
  @Output() currentIndex = new EventEmitter<number>();
  @Output() send = new EventEmitter<any>();

  @ContentChildren(MatStepperCustomStepComponent)
  rowComponents!: QueryList<MatStepperCustomStepComponent>;
  @ViewChild('stepper') myStepper!: MatStepper;
  steps: Array<MatStepperCustomStepComponent> = [];
  // Flag to control template rendering
  viewInitialized = false;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    // Mark view as initialized after view is ready
    this.viewInitialized = true;
    // Manually trigger change detection to avoid the error
    this.cdr.detectChanges();
  }

  closeDialog(): void {
    if (this.dialogRef) this.dialogRef.close();
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.steps = this.rowComponents.toArray();
    }, 0);
  }

  get visibleStepsLength() {
    return this.steps.filter((step) => !step.hide).length;
  }

  get stepperProgress() {
    if (!this.viewInitialized || !this.myStepper) {
      return 0;
    }
    return (this.myStepper.selectedIndex + 1) * (100 / this.visibleStepsLength);
  }

  /**
   * validates the availability of the button for the next step
   * @author Martin Batun Tec.
   */
  get disabled() {
    if (!this.viewInitialized || !this.myStepper) {
      return false;
    }
    return !this.validations[this.myStepper.selectedIndex];
  }

  public previous() {
    this.myStepper.previous();
  }
}
